// eslint-disable-next-line import/no-cycle
import store from '@/store';
import { cloneDeep } from 'lodash';

const ColorCustomizeHelper = {
  setPropertyGroupColors() {
    const inputErrorBorderShadowColor = cloneDeep(store.getters['user/input'].error_border);
    inputErrorBorderShadowColor.rgba.a = '0.25';
    const mainSubTitleColor = cloneDeep(store.getters['user/mainColors'].title);
    mainSubTitleColor.rgba.a = '0.75';
    const explanationBoxBorderColor = cloneDeep(store.getters['user/explanationBox'].text);
    explanationBoxBorderColor.rgba.a = '1';
    const explanationBoxButtonShadowColor = cloneDeep(store.getters['user/explanationBox'].button_text);
    explanationBoxButtonShadowColor.rgba.a = '1';
    const tooltipShadowColor = cloneDeep(store.getters['user/tooltip'].shadow);
    tooltipShadowColor.rgba.a /= 2;
    const colors = [
      {
        variableName: '--background-color',
        color: store.getters['user/mainColors'].background.rgba,
      },
      {
        variableName: '--left-background-color',
        color: store.getters['user/currentColorSchema'].rgba,
      },
      {
        variableName: '--left-text-color',
        color: store.getters['user/currentColorFont'].rgba,
      },
      {
        variableName: '--main-font-color',
        color: store.getters['user/mainColors'].text.rgba,
      },
      {
        variableName: '--main-title-color',
        color: store.getters['user/mainColors'].title.rgba,
      },
      {
        variableName: '--main-sub-title-color',
        color: mainSubTitleColor.rgba,
      },
      {
        variableName: '--horizontal-line-color',
        color: store.getters['user/horizontalLineColor'].rgba,
      },
      {
        variableName: '--radio-button-on-background-color',
        color: store.getters['user/radioButton'].on_background.rgba,
      },
      {
        variableName: '--radio-button-on-border-color',
        color: store.getters['user/radioButton'].on_border.rgba,
      },
      {
        variableName: '--radio-button-on-label-color',
        color: store.getters['user/radioButton'].on_label.rgba,
      },
      {
        variableName: '--radio-button-off-background-color',
        color: store.getters['user/radioButton'].off_background.rgba,
      },
      {
        variableName: '--radio-button-off-border-color',
        color: store.getters['user/radioButton'].off_border.rgba,
      },
      {
        variableName: '--radio-button-off-label-color',
        color: store.getters['user/radioButton'].off_label.rgba,
      },
      {
        variableName: '--checkbox-on-background-color',
        color: store.getters['user/checkbox'].on_background.rgba,
      },
      {
        variableName: '--checkbox-on-border-color',
        color: store.getters['user/checkbox'].on_border.rgba,
      },
      {
        variableName: '--checkbox-on-label-color',
        color: store.getters['user/checkbox'].on_label.rgba,
      },
      {
        variableName: '--checkbox-on-hook-color',
        color: store.getters['user/checkbox'].on_hook.rgba,
      },
      {
        variableName: '--checkbox-off-background-color',
        color: store.getters['user/checkbox'].off_background.rgba,
      },
      {
        variableName: '--checkbox-off-border-color',
        color: store.getters['user/checkbox'].off_border.rgba,
      },
      {
        variableName: '--checkbox-off-label-color',
        color: store.getters['user/checkbox'].off_label.rgba,
      },
      {
        variableName: '--dropdown-background-color',
        color: store.getters['user/dropdown'].background.rgba,
      },
      {
        variableName: '--dropdown-text-color',
        color: store.getters['user/dropdown'].text.rgba,
      },
      {
        variableName: '--dropdown-border-color',
        color: store.getters['user/dropdown'].border.rgba,
      },
      {
        variableName: '--dropdown-opened-border-color',
        color: store.getters['user/dropdown'].opened_border.rgba,
      },
      {
        variableName: '--dropdown-disabled-background-color',
        color: store.getters['user/dropdown'].disabled_background.rgba,
      },
      {
        variableName: '--dropdown-placeholder-color',
        color: store.getters['user/dropdown'].placeholder_color.rgba,
      },
      {
        variableName: '--dropdown-label-background-color',
        color: store.getters['user/dropdown'].label_background.rgba,
      },
      {
        variableName: '--dropdown-label-text-color',
        color: store.getters['user/dropdown'].label_text.rgba,
      },
      {
        variableName: '--left-sidenav-background-color',
        color: store.getters['user/leftSideNav'].background.rgba,
      },
      {
        variableName: '--left-sidenav-text-color',
        color: store.getters['user/leftSideNav'].text.rgba,
      },
      {
        variableName: '--left-sidenav-menu-background-color',
        color: store.getters['user/leftSideNav'].menu_background.rgba,
      },
      {
        variableName: '--left-sidenav-menu-text-color',
        color: store.getters['user/leftSideNav'].menu_text.rgba,
      },
      {
        variableName: '--left-sidenav-submenu-background-color',
        color: store.getters['user/leftSideNav'].sub_menu_background.rgba,
      },
      {
        variableName: '--left-sidenav-submenu-text-color',
        color: store.getters['user/leftSideNav'].sub_menu_text.rgba,
      },
      {
        variableName: '--toggle-text',
        color: store.getters['user/toggleButton'].text.rgba,
      },
      {
        variableName: '--toggle-background',
        color: store.getters['user/toggleButton'].background.rgba,
      },
      {
        variableName: '--toggle-label',
        color: store.getters['user/toggleButton'].label.rgba,
      },
      {
        variableName: '--toggle-off-text',
        color: store.getters['user/toggleButton'].off_text.rgba,
      },
      {
        variableName: '--toggle-off-background',
        color: store.getters['user/toggleButton'].off_background.rgba,
      },
      {
        variableName: '--toggle-off-label',
        color: store.getters['user/toggleButton'].off_label.rgba,
      },
      {
        variableName: '--primary-button-text-color',
        color: store.getters['user/button'].primary.text.rgba,
      },
      {
        variableName: '--primary-button-background-color',
        color: store.getters['user/button'].primary.background.rgba,
      },
      {
        variableName: '--primary-button-hover-background-color',
        color: store.getters['user/button'].primary.hover_background.rgba,
      },
      {
        variableName: '--secondary-button-text-color',
        color: store.getters['user/button'].secondary.text.rgba,
      },
      {
        variableName: '--secondary-button-background-color',
        color: store.getters['user/button'].secondary.background.rgba,
      },
      {
        variableName: '--secondary-button-hover-background-color',
        color: store.getters['user/button'].secondary.hover_background.rgba,
      },
      {
        variableName: '--secondary-button-hover-text-color',
        color: store.getters['user/button'].secondary.hover_text.rgba,
      },
      {
        variableName: '--secondary-button-border-color',
        color: store.getters['user/button'].secondary.border.rgba,
      },
      {
        variableName: '--explanation-box-text-color',
        color: store.getters['user/explanationBox'].text.rgba,
      },
      {
        variableName: '--explanation-box-background-color',
        color: store.getters['user/explanationBox'].background.rgba,
      },
      {
        variableName: '--explanation-box-button-text-color',
        color: store.getters['user/explanationBox'].button_text.rgba,
      },
      {
        variableName: '--explanation-box-button-background-color',
        color: store.getters['user/explanationBox'].button_background.rgba,
      },
      {
        variableName: '--explanation-box-border-color',
        color: explanationBoxBorderColor.rgba,
      },
      {
        variableName: '--explanation-box-button-shadow-color',
        color: explanationBoxButtonShadowColor.rgba,
      },
      {
        variableName: '--avatar-background-color',
        color: store.getters['user/avatar'].background.rgba,
      },
      {
        variableName: '--avatar-color',
        color: store.getters['user/avatar'].color.rgba,
      },
      {
        variableName: '--table-text-color',
        color: store.getters['user/table'].text.rgba,
      },
      {
        variableName: '--table-background-color',
        color: store.getters['user/table'].background.rgba,
      },
      {
        variableName: '--table-header-text-color',
        color: store.getters['user/table'].header_text.rgba,
      },
      {
        variableName: '--table-header-background-color',
        color: store.getters['user/table'].header_background.rgba,
      },
      {
        variableName: '--table-stripe-color',
        color: store.getters['user/table'].stripe.rgba,
      },
      {
        variableName: '--table-horizontal-line-color',
        color: store.getters['user/table'].horizontal_line.rgba,
      },
      {
        variableName: '--table-icon-color',
        color: store.getters['user/table'].icon.rgba,
      },
      {
        variableName: '--table-disabled-icon-color',
        color: store.getters['user/table'].disabled_icon.rgba,
      },
      {
        variableName: '--horizontal-tab-background-color',
        color: store.getters['user/horizontalTab'].background.rgba,
      },
      {
        variableName: '--horizontal-tab-border-color',
        color: store.getters['user/horizontalTab'].border.rgba,
      },
      {
        variableName: '--horizontal-tab-active-color',
        color: store.getters['user/horizontalTab'].active_color.rgba,
      },
      {
        variableName: '--horizontal-tab-passive-color',
        color: store.getters['user/horizontalTab'].passive_color.rgba,
      },
      {
        variableName: '--input-text-color',
        color: store.getters['user/input'].text.rgba,
      },
      {
        variableName: '--input-background-color',
        color: store.getters['user/input'].background.rgba,
      },
      {
        variableName: '--input-border-color',
        color: store.getters['user/input'].border.rgba,
      },
      {
        variableName: '--input-placeholder-color',
        color: store.getters['user/input'].placeholder.rgba,
      },
      {
        variableName: '--input-error-border-color',
        color: store.getters['user/input'].error_border.rgba,
      },
      {
        variableName: '--input-error-border-shadow-color',
        color: inputErrorBorderShadowColor.rgba,
      },
      {
        variableName: '--input-disabled-background-color',
        color: store.getters['user/input'].disabled_background.rgba,
      },
      {
        variableName: '--working-area-text',
        color: store.getters['user/workingArea'].text.rgba,
      },
      {
        variableName: '--working-area-background',
        color: store.getters['user/workingArea'].background.rgba,
      },
      {
        variableName: '--working-area-burger-menu-color',
        color: store.getters['user/workingArea'].burger_menu.rgba,
      },
      {
        variableName: '--working-area-dashboard-icon-color',
        color: store.getters['user/workingArea'].dashboard_icon.rgba,
      },
      {
        variableName: '--modal-background-color',
        color: store.getters['user/modal'].background.rgba,
      },
      {
        variableName: '--modal-text-color',
        color: store.getters['user/modal'].text.rgba,
      },
      {
        variableName: '--modal-body-background-color',
        color: store.getters['user/modal'].body_background.rgba,
      },
      {
        variableName: '--modal-edge-valid-color',
        color: store.getters['user/modal'].edge_valid.rgba,
      },
      {
        variableName: '--modal-edge-invalid-color',
        color: store.getters['user/modal'].edge_invalid.rgba,
      },
      {
        variableName: '--tooltip-background-color',
        color: store.getters['user/tooltip'].background.rgba,
      },
      {
        variableName: '--tooltip-text-color',
        color: store.getters['user/tooltip'].text.rgba,
      },
      {
        variableName: '--tooltip-shadow-first-color',
        color: store.getters['user/tooltip'].shadow.rgba,
      },
      {
        variableName: '--tooltip-shadow-second-color',
        color: tooltipShadowColor.rgba,
      },
      {
        variableName: '--blackout-calendar-background-color',
        color: store.getters['user/blackoutCalendar'].background.rgba,
      },
      {
        variableName: '--blackout-calendar-text-color',
        color: store.getters['user/blackoutCalendar'].text.rgba,
      },
      {
        variableName: '--blackout-calendar-border-color',
        color: store.getters['user/blackoutCalendar'].border.rgba,
      },
      {
        variableName: '--blackout-calendar-inside-border-color',
        color: store.getters['user/blackoutCalendar'].inside_border.rgba,
      },
      {
        variableName: '--blackout-calendar-outside-of-month-background-color',
        color: store.getters['user/blackoutCalendar'].outside_of_month_background.rgba,
      },
      {
        variableName: '--blackout-calendar-content-border-color',
        color: store.getters['user/blackoutCalendar'].content_border.rgba,
      },
      {
        variableName: '--blackout-calendar-blackout-true-color',
        color: store.getters['user/blackoutCalendar'].blackout_true.rgba,
      },
      {
        variableName: '--blackout-calendar-blackout-false-color',
        color: store.getters['user/blackoutCalendar'].blackout_false.rgba,
      },
      {
        variableName: '--blackout-calendar-disabled-date-day-color',
        color: store.getters['user/blackoutCalendar'].disabled_date_day.rgba,
      },
    ];
    colors.forEach((item) => {
      const {
        r, g, b, a,
      } = item.color;
      document.body.style.setProperty(item.variableName, `rgba(${r}, ${g}, ${b}, ${a})`, 'important');
    });
  },

};

export default ColorCustomizeHelper;
